import { Alert, AlertDescription, AlertIcon, AlertTitle, Icon, IconButton, Link, Stack } from '@ecoinvent/ui';
import mixpanel from 'mixpanel-browser';
import { BiX } from 'react-icons/bi';

import useCloseableAlertState from 'hooks/useCloseableAlertState';
import { MIXPANEL_EVENTS } from 'utilities/constants/mixpanel';

const AnnouncementBanner = () => {
  const { isOpen, onClose } = useCloseableAlertState('313Release');

  if (!isOpen) {
    return null;
  }

  const handleDiscoverMoreClick = () => {
    mixpanel.track(MIXPANEL_EVENTS.RELEASE_313_BANNER_CLICKED, { CTA: 'Discover More' });
  };

  const handleDismiss = () => {
    mixpanel.track(MIXPANEL_EVENTS.RELEASE_313_BANNER_DISMISSED, { Method: 'Close Icon' });
    onClose();
  };

  return (
    <Stack p={3} px={5}>
      <Alert rounded="lg" flexDirection="row" alignItems="center">
        <AlertIcon />
        <AlertTitle fontSize={'sm'} mr={2}>
          ecoinvent version 3.13 is now available.
        </AlertTitle>
        <AlertDescription fontSize={'sm'} width={'100%'} flex={1}>
          Introducing a new pharma sector, expanded geographical coverage, and sector-specific updates.{' '}
          <Link href="https://ecoinvent.org/ecoinvent-v3-13/" isExternal colorScheme="blue" onClick={handleDiscoverMoreClick}>
            Discover More
          </Link>
        </AlertDescription>
        <IconButton
          onClick={handleDismiss}
          aria-label={'close'}
          icon={<Icon as={BiX} />}
          size={'xs'}
          fontSize={'lg'}
          variant={'ghost'}
          colorScheme="blue"
        />
      </Alert>
    </Stack>
  );
};

export default AnnouncementBanner;
